<template>
  <UsageExample v-model="tab" :code="code" :tabs="tabs">
    <v-container class="d-flex flex-column ga-3">
      <v-row>
        <v-col>
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Success</v-card-title>
            <v-card-text
              :class="['d-flex flex-wrap', { 'overflow-y-auto': scrollable }]"
              :style="{ height: scrollable ? '150px' : 'auto' }"
            >
              <HxInformationBar id="information-bar-success" :message="message" />
              <div v-if="scrollable" style="height: 190px">Some content</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Informative</v-card-title>
            <v-card-text class="d-flex flex-wrap">
              <HxInformationBar
                id="information-bar-informative"
                :message="message"
                variant="informative"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Error</v-card-title>
            <v-card-text class="d-flex flex-wrap">
              <HxInformationBar id="information-bar-error" :message="message" variant="error" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Queue</v-card-title>
            <v-card-text class="d-flex flex-wrap">
              <HxInformationBar id="information-bar-queue" :message="message" variant="queue" />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card elevation="4">
            <v-card-title class="font-weight-bold">Submitting</v-card-title>
            <v-card-text class="d-flex flex-wrap">
              <HxInformationBar
                id="information-bar-submitting"
                :message="message"
                variant="submitting"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <template #configuration>
      <div class="d-flex flex-column mt-16">
        <hx-checkbox v-model="longMessage" :label="`Long message: ${longMessage}`" />
        <hx-checkbox v-model="scrollable" :label="`Scrollable: ${scrollable}`" />
      </div>
    </template>
  </UsageExample>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixInformationBar',
  components: { UsageExample },
  setup() {
    const code = `
    <HxInformationBar id="information-bar-success" :message="message" />
    <HxInformationBar id="information-bar-informative" :message="message" variant="informative" />
    <HxInformationBar id="information-bar-error" :message="message" variant="error" />
    <HxInformationBar id="information-bar-queue" :message="message" variant="queue" />
    <HxInformationBar id="information-bar-submitting" :message="message" variant="submitting" />`;
    return { code };
  },
  data() {
    return {
      tab: 'Information Bar Usage',
      tabs: ['Information Bar Usage'],
      longMessage: false,
      scrollable: false
    };
  },
  computed: {
    message() {
      return this.longMessage
        ? 'This very long and simple report is linked to another module.'
        : 'This report is linked to another module.';
    }
  }
};
</script>
